export default __webpack_public_path__ + "static/media/arrow_blue_right.edb04b78.svg";